import {Component, inject, OnInit} from '@angular/core';
import {Toolbar} from "primeng/toolbar";
import {NgOptimizedImage} from "@angular/common";
import {Divider} from "primeng/divider";
import {Avatar} from "primeng/avatar";
import {Button} from "primeng/button";
import {Tooltip} from "primeng/tooltip";
import {AuthService} from "@core/services/auth.service";
import {StringUtils} from "@shared/utils/string.utils";
import {ProfileClaims} from "@core/models/profile-claims";
import {RouterLink} from '@angular/router';
import {environment} from "@environments/environment";
import {SeiService} from "@core/services/sei.service";
import {SeiStatus} from "@components/layout/sei-status/sei-status";

@Component({
  selector: 'app-header',
  imports: [
    Toolbar,
    NgOptimizedImage,
    Divider,
    Avatar,
    Button,
    Tooltip,
    RouterLink,
    SeiStatus,
  ],
  templateUrl: './header.html',
  styleUrl: './header.css'
})
export class Header implements OnInit {
  user: ProfileClaims | null = null;
  initials: string = '';
  authenticated: boolean = false;
  isDark: boolean = false;
  protected readonly version: string = environment.version;
  private authService = inject(AuthService);
  // também liga o SeiService logo no início (marca o <html> pra extensão SisNot ↔ SEI)
  protected sei = inject(SeiService);

  ngOnInit() {
    this.authenticated = this.authService.isAuthenticated();
    this.user = this.getUserAuthenticated();
    this.initials = this.getFirstAndLastInitials();
    this.isDark = localStorage.getItem('theme') === 'dark';
    this.applyTheme();
  }

  getUserAuthenticated(): ProfileClaims | null {
    return this.authService.getProfileClaims();
  }

  getFirstAndLastInitials() {
    return StringUtils.getFirstAndLastInitials(this.user?.name || '');
  }

  login() {
    this.authService.login();
  }

  logout() {
    this.authService.logout();
  }

  toggleTheme() {
    this.isDark = !this.isDark;
    localStorage.setItem('theme', this.isDark ? 'dark' : 'light');
    this.applyTheme();
  }

  private applyTheme() {
    if (this.isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }
}
